import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { signInWithGoogle } = useAuth();

  return (
    <div style={{display:'flex', alignItems:'center', justifyContent:'center',
                 minHeight:'100vh', background:'#f0f2f8'}}>
      <div style={{textAlign:'center', background:'#fff', padding:48,
                   borderRadius:12, maxWidth:400, width:'100%',
                   boxShadow:'0 4px 24px rgba(0,0,0,0.08)'}}>
        <img src="/nimble-flag-dark.png" alt="Nimble"
             style={{width:140, marginBottom:24}} />
        <h2 style={{fontFamily:'Syne,sans-serif', color:'#000F9F',
                    marginBottom:8}}>Customer Updates</h2>
        <p style={{color:'#6b7280', fontSize:13, marginBottom:32}}>
          Sign in with your Nimble account to continue
        </p>
        <button
          onClick={signInWithGoogle}
          style={{display:'flex', alignItems:'center', justifyContent:'center',
                  gap:12, width:'100%', padding:'12px 24px',
                  background:'#fff', border:'2px solid #e2e5f0',
                  borderRadius:8, fontSize:14, fontWeight:600,
                  cursor:'pointer', color:'#333'}}
        >
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/>
            <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"/>
            <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z"/>
            <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z"/>
          </svg>
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
